/**
 * テナント一覧の表示制御。
 * ビルド時に REACT_APP_HIDDEN_TENANT_SUBSTRINGS を設定（カンマ区切り、部分一致）。
 * 例: REACT_APP_HIDDEN_TENANT_SUBSTRINGS=公益,収益,社会福祉法人 竹の子福祉会
 */

export const LAST_SELECTED_TENANT_ID_KEY = 'lastSelectedTenantId';

export function parseHiddenTenantSubstrings(): string[] {
  const raw = process.env.REACT_APP_HIDDEN_TENANT_SUBSTRINGS || '';
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function isTenantNameHidden(tenantName: string | null, tenantCode: string | null): boolean {
  const subs = parseHiddenTenantSubstrings();
  if (subs.length === 0) return false;
  const hay = `${tenantName ?? ''} ${tenantCode ?? ''}`.trim();
  return subs.some((s) => hay.includes(s));
}

export function filterTenantsForDisplay<T extends { id?: number | null; tenant_name?: string | null; tenant_code?: string | null }>(
  tenants: T[],
  currentId?: number | null,
): T[] {
  if (parseHiddenTenantSubstrings().length === 0) return tenants;
  return tenants.filter((t) => {
    if (currentId != null && t.id === currentId) return true;
    return !isTenantNameHidden(t.tenant_name ?? null, t.tenant_code ?? null);
  });
}
